import { afterNextRender, computed, DestroyRef, ElementRef, inject, Signal, signal } from '@angular/core';
import { animationFrameScheduler, debounceTime, Subject } from 'rxjs';

/**
 * Berekent een barWidth-signal die live meeschaalt met de breedte van `.panel-content` (via
 * ResizeObserver), zodat een app-vbar-series-grafiek altijd binnen zijn paneel blijft in plaats van
 * een vaste breedte te forceren die het paneel kan laten overlopen.
 */
export function createResponsiveBarWidth(elementRef: ElementRef, partitionCount: number, paddingLeft = 0): Signal<number> {
	const destroyRef = inject(DestroyRef);
	const containerWidth = signal(paddingLeft + partitionCount * 40); // Default waarde, voordat de eerste meting binnen is
	const resizeSubject = new Subject<number>();

	const resizeSubscription = resizeSubject.pipe(debounceTime(0, animationFrameScheduler)).subscribe((width) => {
		containerWidth.set(width);
	});

	let resizeObserver: ResizeObserver | undefined;

	afterNextRender(() => {
		const panelContent: HTMLElement | null = elementRef.nativeElement.querySelector('.panel-content');
		if (!panelContent) return;

		containerWidth.set(panelContent.clientWidth);

		resizeObserver = new ResizeObserver(([{ contentRect }]) => {
			resizeSubject.next(contentRect.width);
		});
		resizeObserver.observe(panelContent);
	});

	destroyRef.onDestroy(() => {
		resizeObserver?.disconnect();
		resizeSubscription.unsubscribe();
		resizeSubject.complete();
	});

	return computed(() => (containerWidth() - paddingLeft) / partitionCount);
}
